import { __extends } from "tslib";
import { searchAndInitialize } from "../Utils";
import DomElement from "../DomElement";
/**
 * Loader bar component
 */
var LoaderBar = /** @class */ (function (_super) {
    __extends(LoaderBar, _super);
    /**
     * Creates and initializes the LoaderBar component.
     * @param {Element} - The root element of the LoaderBar component.
     */
    function LoaderBar(element) {
        var _this = _super.call(this, element) || this;
        _this._initialize();
        return _this;
    }
    /**
     * Initializes the loader bar component.
     * @private
     */
    LoaderBar.prototype._initialize = function () {
        this.progressElement = this.find(".indicator") || this;
        this.fileNameElement = this.find(".detail > .name");
        this.progressLabelElement = this.find(".progress");
        this.totalProgressElement = this.find(".file-size");
    };
    Object.defineProperty(LoaderBar.prototype, "progress", {
        /**
         * Gets the current progress value in the range of 0..1.
         */
        get: function () {
            return this.value;
        },
        /**
         * Sets the current progress.
         * @param {number} - The progress in the range of 0..1.
         */
        set: function (val) {
            // val = clamp(val, 0, 1)
            var percentage = (val * 100).toFixed(0);
            this.value = val;
            this.element.value = String(val);
            this.progressElement.setAttribute("style", "width: ".concat(val * 100, "%"));
            if (this.progressLabelElement) {
                this.progressLabelElement.element.textContent = "".concat(percentage, "%");
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LoaderBar.prototype, "filename", {
        /**
         * Gets the filename.
         * @returns {string} - The filename.
         */
        get: function () {
            if (!this.fileNameElement) {
                return undefined;
            }
            return this.fileNameElement.element.textContent || undefined;
        },
        /**
         * Sets the filename.
         */
        set: function (val) {
            if (!this.fileNameElement) {
                throw new Error("Cannot set the filename, missing detail element");
            }
            this.fileNameElement.setHtml(val || "");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LoaderBar.prototype, "fileSize", {
        /**
         * Sets the file size label.
         */
        set: function (val) {
            if (!this.totalProgressElement) {
                throw new Error("Cannot set the fileSize, missing detail element");
            }
            this.totalProgressElement.setHtml(val);
        },
        enumerable: false,
        configurable: true
    });
    return LoaderBar;
}(DomElement));
export function init() {
    searchAndInitialize(".loader-bar", function (e) {
        new LoaderBar(e);
    });
}
export default LoaderBar;
